var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25842 7L12.7115 2.54687C12.9229 2.3359 13.0418 2.04962 13.042 1.75099C13.0423 1.45237 12.9239 1.16587 12.7129 0.95453C12.502 0.743185 12.2157 0.624305 11.9171 0.624041C11.6184 0.623778 11.3319 0.742152 11.1206 0.953123L6.66748 5.40625L2.21435 0.953123C2.00301 0.741779 1.71636 0.623047 1.41748 0.623047C1.11859 0.623047 0.831948 0.741779 0.620604 0.953123C0.40926 1.16447 0.290527 1.45111 0.290527 1.75C0.290527 2.04888 0.40926 2.33553 0.620604 2.54687L5.07373 7L0.620604 11.4531C0.40926 11.6645 0.290527 11.9511 0.290527 12.25C0.290527 12.5489 0.40926 12.8355 0.620604 13.0469C0.831948 13.2582 1.11859 13.3769 1.41748 13.3769C1.71636 13.3769 2.00301 13.2582 2.21435 13.0469L6.66748 8.59375L11.1206 13.0469C11.3319 13.2582 11.6186 13.3769 11.9175 13.3769C12.2164 13.3769 12.503 13.2582 12.7144 13.0469C12.9257 12.8355 13.0444 12.5489 13.0444 12.25C13.0444 11.9511 12.9257 11.6645 12.7144 11.4531L8.25842 7Z",
    fill: "#D2D2D2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.c056a11c16f8d14c3f40ff440f80463b.svg";
export { ForwardRef as ReactComponent };